import { EVENTS } from '../utils/constants.js'
import makeSignup from '../applications/makeSignup.js'
import publishUserData from '../applications/publishUserData.js'

class OnSignupFormSubmitted {
  static register(context) {
    context.events.handle(EVENTS.SIGNUP_FORM_SUBMITTED, async payload => {
      try {
        const signupRes = await makeSignup(context, payload)
        if (!signupRes.success) return
        await publishUserData(context)
        context.events.dispatch(EVENTS.USER_CONNECTED)
      } catch (error) {
        console.log('🚀 ~ OnSignupFormSubmitted ~ register ~ error:', error)
        context.sendBugAlert(error)
      }
    })
  }
}
export default OnSignupFormSubmitted
